<template>
    <div class="input-group">
        <label>{{label}}</label>
        <select v-model="model.value" @input="input">
            <option value="">Seleccione</option>
            <option v-for="option in options" :value="option.value">{{option.label}}</option>
        </select>
        <i class="bar"></i>

    </div>
</template>
<script>
    export default {
        name: 'selectForm',
        props: ['options', 'label', 'name'],
        data(){
            return {
                model: {
                    value: '',
                    name: this.name
                }
            }
        },
        methods: {
            input(event) {
                this.model.value = event.target.value
                this.$emit('input', this.model)
            }
        }
    }
</script>
